<div [innerHTML]="text" class="mention"></div>
